export const valueText = "text-sm text-darkBlue";
